(() => {
  const groups = {"boots":["vintage-yellow-boots","washed-leather-chelsea-boots","washed-leather-combat-boots","vegetable-tanned-black-boots","polished-winter-boots","reverse-leather-shaft-boots","yaoyao-sole-ankle-boots","snow-cap-coffee-snow-boots"],"sneaker":["women-s-brown-suede-retro-casual-sneakers","women-s-vintage-green-suede-casual-sneakers","women-s-white-purple-retro-casual-sneakers","women-s-black-retro-casual-sneakers","women-s-natural-suede-retro-low-top-sneakers"],"women-s-shoes-collection":["lotus-ic-german-trainers","red-white-retro-german-trainers","slim-white-sneakers","black-egg-roll-shoes","puff-shoes","ballet-red-shoes"],"all":["lambskin-sock-boots","vintage-yellow-boots","washed-leather-chelsea-boots","washed-leather-combat-boots","vegetable-tanned-black-boots","polished-winter-boots","reverse-leather-shaft-boots","yaoyao-sole-ankle-boots","snow-cap-coffee-snow-boots","women-s-brown-suede-retro-casual-sneakers","women-s-vintage-green-suede-casual-sneakers","women-s-white-purple-retro-casual-sneakers","women-s-black-retro-casual-sneakers","women-s-natural-suede-retro-low-top-sneakers","lotus-ic-german-trainers","red-white-retro-german-trainers","slim-white-sneakers","black-egg-roll-shoes","puff-shoes","ballet-red-shoes"]};
  function shuffle(items) {
    for (let i=items.length-1;i>0;i--) {const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]];}
    return items;
  }
  class CuratedGrid extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if(this.dataset.sort !== 'manual' || this.dataset.curatedReady) return;
        const handles=groups[this.dataset.collection];
        const grid=this.querySelector('[data-product-container]');
        if(!handles || !grid) return;
        this.dataset.curatedReady='true';
        const items=[...grid.children];
        const fixed=this.dataset.collection==='boots'?handles.slice(0,4):this.dataset.collection==='all'?['lambskin-sock-boots']:[];
        const pinned=fixed.map(h=>items.find(n=>n.dataset.curatedHandle===h)).filter(Boolean);
        const random=items.filter(n=>handles.includes(n.dataset.curatedHandle)&&!fixed.includes(n.dataset.curatedHandle));
        const remaining=items.filter(n=>!handles.includes(n.dataset.curatedHandle));
        grid.append(...pinned,...shuffle(random),...remaining);
      });
    }
  }
  class BootPicks extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if(this.dataset.curatedReady) return;
        const grid=this.querySelector('.arte-boot-picks-grid');
        if(!grid) return;
        this.dataset.curatedReady='true';
        const items=shuffle([...grid.children]);
        const limit=Math.max(1,Number(this.dataset.limit)||4);
        items.slice(limit).forEach(n=>n.remove());
        grid.append(...items.slice(0,limit));
      });
    }
  }
  if(!customElements.get('arte-curated-grid'))customElements.define('arte-curated-grid',CuratedGrid);
  if(!customElements.get('arte-boot-picks'))customElements.define('arte-boot-picks',BootPicks);
})();
